/**
 * The SPA's own build-time version (manager decision, 2026-09-11): set from
 * VITE_APP_VERSION, a Vite build-time environment variable
 * (docker/portal/Dockerfile passes it as the VERSION build arg, the same
 * CI-computed release version baked into cmd/portal and cmd/scanner via
 * -ldflags). `npm run dev`/`npm run build` run outside that Dockerfile leave
 * it unset, so this falls back to "dev", matching the Go services' own
 * default for a plain, non-Docker build.
 */
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION || "dev";
